/**
 * Given milliseconds, returns a friendly string representing the time.
 * If the time is less than 5 seconds, it will be rounded to the nearest
 * millisecond. If the time is less than 1 minute, it will be displayed
 * in seconds. If the time is less than 1 hour, it will be displayed in
 * minutes and seconds. If the time is less than 1 day, it will be
 * displayed in hours, minutes, and seconds.
 */
export function formatTime(time: number): string {
  if (time < 5000) {
    return `${Math.round(time)}ms`;
  }

  if (time < 60000) {
    return `${Math.round((100 * time) / 1000) / 100}s`;
  }

  if (time < 3600000) {
    const minutes = Math.floor(time / 60000);
    const seconds = Math.round((time - minutes * 60000) / 1000);
    return `${minutes}m ${seconds}s`;
  }

  const hours = Math.floor(time / 3600000);
  const minutes = Math.round((time - hours * 3600000) / 60000);

  return `${hours}h ${minutes}m`;
}
